import { render, staticRenderFns } from "./erp.vue?vue&type=template&id=62aa17a6"
import script from "./erp.vue?vue&type=script&lang=js"
export * from "./erp.vue?vue&type=script&lang=js"
import style0 from "./erp.vue?vue&type=style&index=0&id=62aa17a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports